<template>
	<div class="consus" style="width: 100%;background-image: linear-gradient(#00b0f0, #f5f5f5, #f5f5f5);">
		<!--轮播图-->
		<div class="swiper">
			<el-carousel :interval="4000" arrow="always" height="480px">
			    <el-carousel-item v-for="item in imgarr" :key="item" class="el-carousel-item"
				style="
				    transform: translateX(0px) scale(1);
				    background-size: cover;
				    background-repeat: no-repeat;
				    background-position: 50% 50%;
				    background-color: rgba(120, 120, 120, 0.1);
				"
				:style="{backgroundImage:'url('+ item +')'}"
				>
			    </el-carousel-item>
			  </el-carousel>
		</div>
		<div style="width: 80%;margin: 0 auto;background: #fff;padding-top: 20px;padding-bottom: 50px;">
			<div class="wrapper">
				<!--新闻中心-->
				<div class="wrappers" style="box-shadow:0px 15px 10px -15px #000;padding-bottom: 20px;">
					<div class="wrappers01">
						<div class="flexgb">
							<div class="nav">
								<div class="navs navssss" @click="newclick(1)" :class="[type==1?'navss':'']">
									<img src="../../assets/xinwen.png" alt="" v-if="type==1">
									新闻中心</div>
								<div class="navs navssss" @click="newclick(2)" :class="[type==2?'navss':'']">
									<img src="../../assets/xinwen.png" alt="" v-if="type==2">
									资源下载</div>
								<div class="navs" @click="newclick(3)" :class="[type==3?'navss':'']">
									<img src="../../assets/xinwen.png" alt="" v-if="type==3">
									活动公告</div>
							</div>
							
							<div class="flexAc"  @click="listclick">更多
							 <img src="../../assets/gengduo.png" alt="" style="width: 25px;">
							</div>
						</div>
						<div class="transition" style="height: 568px;">
							<div v-loading="loading">
								<div class="list">
									<div class="lists" v-for="(item,i) in list" v-if="i<2" :key="i" @click="newsdetail(item.id)">
										<div class="list01">
											<img :src="item.imgurl" alt="">
										</div>
										<div class="list02">
											{{item.title}}
										</div>
										<div class="list03">
											{{item.intor}}
										</div>
										<div class="list04">
											<div class="time">
												{{bian(item.createTime).year}}-{{bian(item.createTime).month}}-{{bian(item.createTime).day}}
											</div>
											<div class="time01">了解详情
											  <img src="../../assets/xiangyou.png" alt="">
											</div>
										</div>
									</div>
								</div>
								<div class="list" style="padding-top: 29px;">
									<div class="list05">
										<div class="list05s" v-for="(item,i) in list" :key="i" v-if="i>1 && i<6" @click="newsdetail(item.id)">
											<img src="@/assets/gengduos.png" alt="">
											<div class="list05title">
												{{item.title}}
											</div>
											<div class="list05time">
												{{bian(item.createTime).year}}-{{bian(item.createTime).month}}-{{bian(item.createTime).day}}
											</div>
										</div>
									</div>
									<div class="list05" style="margin-left: auto;">
										<div class="list05s" v-for="(item,i) in list" :key="i" v-if="i>5 && i<10" @click="newsdetail(item.id)">
											<img src="@/assets/gengduos.png" alt="">
											<div class="list05title">
												{{item.title}}
											</div>
											<div class="list05time">
												{{bian(item.createTime).year}}-{{bian(item.createTime).month}}-{{bian(item.createTime).day}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--热门话题-->
					<div class="wrappers02">
						<div class="flexgb"  @click="gengduo">
							<div class="nav">
								<div class="navs navss">
									<img src="@/assets/xinwen.png" alt="">
									热门话题</div>
							</div>
							<div class="flexAc">更多
							 <img src="../../assets/gengduo.png" alt="" style="width: 25px;">
							</div>
						</div>
						<div class="transition">
							<div class="huati">
								<div class="huatis" v-for="(item,i) in bokelist" @click="detail(item.id)" :key="i">
									<div class="huati01">
										<div class="huati001" v-for="(items,j) in yuefen" :key="j" v-if="bian(item.createTime).month==items.name">
											{{items.eng}}
										</div>
										<div class="huati002"></div>
										<div class="huati003">{{bian(item.createTime).month}}-{{bian(item.createTime).day}}</div>
									</div>
									<div class="clears"></div>
									<div class="huati02">
										<div class="h01">{{item.title}}</div>
										<div class="h02" style="display: flex;align-items: center;">了解更多
										 <img src="../../assets/向右.png" alt="" style="width: 20px;margin-left: 10px;">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!--新闻中心-->
				<!--环境-->
				<div>
					<div class="wrappers" style="margin-top: 30px;">
						<div class="wrappers01" style="width: 1200px;">
							<div class="flexgb">
								<div class="nav">
									<div class="navs navssss" @click="newclicks(1)" :class="[types==1?'navss':'']">
										<img src="../../assets/xinwen.png" alt="" v-if="types==1">
										公开参观环境</div>
									<div class="navs navssss" @click="newclicks(2)" :class="[types==2?'navss':'']">
										<img src="../../assets/xinwen.png" alt="" v-if="types==2">
										技术验证环境</div>
									<div class="navs navssss" @click="newclicks(3)" :class="[types==3?'navss':'']">
										<img src="../../assets/xinwen.png" alt="" v-if="types==3">
										共享开发环境
									</div>
									<div class="navs" @click="newclicks(4)" :class="[types==4?'navss':'']">
										<img src="../../assets/xinwen.png" alt="" v-if="types==4">
										专享开发环境
									</div>
								</div>
								
								<div class="huanjingleft03s">
									<div class="huanjingleft03ss ss">
										<input type="text" v-model="title" placeholder="请输入搜索关键词" class="ssinput" />
										<i class="el-icon-search el-icon-searchsss" @click="huanjing_look()"></i>
									</div>
								</div>
								
								
								<el-button type="primary" @click="sqs" size="small" style="width: 65px;height: 31px;margin-top: 12px;border-radius: 25px;margin-left: 30px;">
									申请
								</el-button>
								<div class="flexAc"  @click="huanjinglist">更多
								 <img src="../../assets/gengduo.png" alt="" style="width: 25px;">
								</div>
							</div>
						</div>
					</div>
				</div>
				<div style="width: 1200px;margin-top: 30px;display: flex;">
					<div class="huanjingright" v-loading="loadings">
						<div class="huanjingrights" @mouseenter="mouseenter($event,i)" @mouseleave="mouseleave($event,i)"  @click="tiaozhuans(item.url)" v-for="(item,i) in lists" :key="i">
							<img src="../../assets/zanwu.png" v-if="!item.icon" class="zhubeijing" alt="" >
							<img :src="item.icon" v-if="item.icon" class="zhubeijing" alt="">
							
							<div style="width: 100%;height: 60px;position: absolute;bottom: 0px;z-index: 2;">
								<div style="width: 100%;height: 100%;background: #037db3;opacity: 0.7;"></div>
								<div class="tiaozhuan" style="cursor: pointer;">
									<div style="width: 80%;position: relative;display: flex;align-items: center;">
										<div class="jhsas" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;height: 100%;line-height: 60px;">
											{{item.title}}
										</div>
										<img src="../../assets/xanyou.png" style="width: 30px;" alt="">
									</div>
									<img :src="item.slogo" alt="" v-if="item.slogo" class="slogis">
							<!-- 		<div class="imagss" v-if="!item.slogo">暂无</div> -->
								</div>
							</div>
							
							<!--申请运行资源 申请上线运行-->
							<div class="shenqing" v-if="(item.type==3 || item.type==4) && item.select==true">
								<div class="shenqings" @click.stop="user_is_huanjing(item,1)">申请运行资源</div>
								<div class="shenqings" @click.stop="user_is_huanjing(item,2)">申请上线运行</div>
								<div class="shenqings" v-if="item.type==3" @click.stop="shenqingjiaru(item.id,item.title)">申请加入</div>
								<div class="shenqings" v-if="item.type==3" style="margin-top: 10px;" @click.stop="xufeidata(item.id)">用户续费</div>
							</div>
							
							<!--加入管理-->
<!-- 							<div class="jiaru"  v-if="item.type==3">
								<div class="jiarus" @click="shenqingjiaru(item.id,item.title)">申请加入</div>
							</div> -->
							
						</div>
					</div>
				</div>
				<!--环境-->
			</div>
		</div>
		
		<!--申请运行资源-->
		<yunxing ref="yunxingdata" @yunxingsucc="yunxingsucc"></yunxing>
		<!--申请运行资源-->
		<!--申请上线运行-->
		<shangxian ref="shangxiandata" @shangxiansucc="shangxiansucc"></shangxian>
		<!--申请上线运行-->
		<!--用户续费-->
		<userxufei ref="xufeidata" @succ="xufeichenggong"></userxufei>
		<!--用户续费-->
	</div>
</template>
<script>
	import { news_list } from "@/api/news"
	import { TimeYYdAY } from "@/utils/rules"
	import { wxlogin } from "@/api/user"
	import { getQueryVariable } from "@/utils/rules"
	import { user_boke_list } from "@/api/boke"
	import { huanjing_look,user_is_huanjing } from "@/api/huanjing"
	import { getToken } from '@/utils/auth'
	import Cookies from 'js-cookie'
	import yunxing from "@/views/yunxing/index"
	import shangxian from "@/views/yunxing/shangxian"
	import userxufei from "@/views/erqi/userxufei"
	export default {
		components:{
			yunxing,shangxian,userxufei
		},
		data(){
			return{
				imgarr:[
					"https://www.metabiz.com.cn/lunbo/lunbo01.jpg",
					"https://www.metabiz.com.cn/lunbo/lunbo02.jpg",
					"https://www.metabiz.com.cn/lunbo/lunbo03.jpg",
					"https://www.metabiz.com.cn/lunbo/lunbo04.jpg"
				],
				type:1,//1新闻中心 2资源下载 3活动公告
				types:1,//1公开参观环境 2技术验证环境 3共享开发环境 4专享开发环境
				list:[],
				lists:[],//环境列表
				loadings:false,
				loading:false,
				bokelist:[],
				yuefen:[
					{name:'01',eng:"JAN"},{name:'02',eng:"FEB"},{name:'03',eng:"MAR"},
					{name:'04',eng:"APR"},{name:'05',eng:"MAY"},{name:'06',eng:"JUN"},
					{name:'07',eng:"JUL"},{name:'08',eng:"AUG"},{name:'09',eng:"SEP"},
					{name:'10',eng:"OCT"},{name:'11',eng:"NOV"},{name:'12',eng:"DEC"}
				],
				
				title:'',//环境搜索关键词
			}
		},
		mounted(){
			// Cookies.set("Token","89e67d2c3348d07ee0b137ac72406960");
			document.title = "MetaBiz-门户首页";
			this.news_list();
			this.user_boke_list();//热门话题
			this.huanjing_look();//请求环境列表
		},
		methods:{
			xufeichenggong(orderid){
				this.$router.push({
					path:"/neirong",
					query:{
						orderid:orderid,
						neirongtype:5
					}
				})
			},
			//用户续费
			xufeidata(huanjingid){
				if(getToken()){
					this.$refs.xufeidata.show(huanjingid)
				}else{
					loginEvent.$emit('loginDialogEvent')
				}
				
			},
			mouseenter($event,i){
				this.lists.forEach((r,j)=>{
					if(i==j){
						r.select = true
					}else{
						r.select = false
					}
				})
			},
			mouseleave($event,i){
				this.lists.forEach((r,j)=>{
					if(i==j){
						r.select = false
					}
				})
			},
			tiaozhuans(url){
				window.open(url, '_blank');
			},
			newsdetail(id){
				this.$router.push({
					path:"/newsdetail",
					query:{
						id:id
					}
				})
			},
			//申请运行资源成功以后进行跳转订单
			yunxingsucc(orderid){
				this.$router.push({
					path:"/neirong",
					query:{
						orderid:orderid,
						neirongtype:2
					}
				})
			},
			shangxiansucc(orderid){
				this.$router.push({
					path:"/neirong",
					query:{
						orderid:orderid,
						neirongtype:3
					}
				})
			},
			user_is_huanjing(item,st){
				//申请运行资源
				if(st==1){
					this.$refs.yunxingdata.show(item);
				}
				//申请上线运行
				if(st==2){
					this.$refs.shangxiandata.show(item)
				}
				// const loading = this.$loading({
				//   lock: true,
				//   text: 'Loading',
				//   spinner: 'el-icon-loading',
				//   background: 'rgba(0, 0, 0, 0.7)'
				// });
				// user_is_huanjing({
				// 	id:item.id,
				// 	type:item.type
				// }).then((res)=>{
				// 	loading.close();
				// 	console.log("运行成功",res,st);
				// 	//申请运行资源
				// 	if(st==1){
				// 		this.$refs.yunxingdata.show(item);
				// 	}
				// 	//申请上线运行
				// 	if(st==2){
				// 		this.$refs.shangxiandata.show(item)
				// 	}
				// }).catch(()=>{
				// 	loading.close();
				// })
			},
			gengduo(){
				window.open("/#/portal", '_blank');
				// this.$router.push({
				// 	path:"/boke"
				// })
			},
			user_boke_list(){
				user_boke_list({
					page:1,
					limit:8
				}).then(res=>{
					this.bokelist = res.data.list
				})
			},
			huanjinglist(){
				this.$router.push({
					path:"/huanjinglist",
					query:{
						type:this.types
					}
				})
			},
			//共享环境申请加入
			shenqingjiaru(id,title){
				//需要先判断是否登录
				if(getToken()){
					//如果是共享环境开发
					if(this.types==3){
						this.$router.push({
							path:"/gongxiangsave",
							query:{
								huanjingid:id,
								title:title
							}
						})
					}
				}else{
					loginEvent.$emit('loginDialogEvent')
				}
			},
			bian(time){
				let date = new Date(time);
				return TimeYYdAY(date);
			},
			detail(id){
				this.$router.push({
					path:'/bokedetail',
					query:{
						id:id
					}
				})
			},
			listclick(){
				this.$router.push({
					path:'/newslist',
					query:{
						type:this.type
					}
				})
			},
			//申请环境
			sqs(){
				console.log("去申请环境");
				this.$router.push({
					path:"/hj0" + this.types
				})
			},
			newclick(type){
				this.type = type
				this.news_list();
			},
			newclicks(type){
				this.types = type
				this.huanjing_look();//环境列表
			},
			huanjing_look(){
				this.loadings = true
				this.lists = [];
				huanjing_look({
					page:1,
					limit:4,
					type:this.types,
					status:2,//已完成状态
					title:this.title
				}).then(res=>{
					this.loadings = false
					console.log("共享环境",res.data.list);
					res.data.list.forEach(r=>{
						r.select = false
					})
					this.lists = res.data.list
				}).catch(()=>{
					this.loadings = false
				})
			},
			news_list(){
				this.loading = true
				if(this.type==1){
					this.list = []
				news_list({
					page:1,
					limit:10,
					type:1,
				}).then(res=>{
					this.loading = false
					console.log("新闻中心",res.data.list);
					this.list = res.data.list
				}).catch(()=>{
					this.loading = false
				})	
				}
				if(this.type==2){
					this.list = []
				  news_list({
				  	page:1,
				  	limit:10,
				  	type:2,
				  }).then(res=>{
				  	this.loading = false
				  	console.log("资源下载",res.data.list);
				  	this.list= res.data.list
				  }).catch(()=>{
				  	this.loading = false
				  })	
				}
				if(this.type==3){
					this.list = []
				   news_list({
				   	page:1,
				   	limit:10,
				   	type:3,
				   }).then(res=>{
				   	this.loading = false
				   	console.log("活动公告",res.data.list);
				   	this.list = res.data.list
				   }).catch(()=>{
				   	this.loading = false
				   })	
				} 
			},
		},
	}
</script>
<style lang="scss" scoped>
	.huanjingleft03s{
		width: 162px;
		// height: 93%;
		margin-left: auto;
		// border-bottom: 2px solid #00b0f0;
		.huanjingleft03ss{
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
		}
	}
	.jiaru{
		width: 80px;
		position: absolute;
		right: 20px;
		bottom: 62px;
		z-index: 2;
		display: flex;
		.jiarus{
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #fff;
			font-size: 16px;
			cursor: pointer;
		}
	}
	.shenqing{
		width: 132px;
		height: 78%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		position: absolute;
		left: 50%;
		margin-left: -66px;
		top: 0px;
		z-index: 2;
		.shenqings{
			width: 100%;
			height: 30px;
			border: 2px solid #fff;
			border-radius: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #fff;
			font-size: 16px;
			cursor: pointer;
			transition: all 1s;
			background: rgba(3, 125, 179, 0.7);
		}
		.shenqings:nth-child(2){
			margin-top: 10px;
			margin-bottom: 10px;
		}
		
	}
	.tiaozhuan{
		width: 245px;
		position: absolute;
		left: 16px;
		height: 100%;
		bottom: 0px;
		display: flex;
		align-items: center;
		color: #fff;
		font-size: 16px;
		z-index: 2;
		.slogis{
			height: 60px;
			margin-left: auto;
			position: absolute;
			right: -18px;
			cursor: pointer;
		}
		.imagss{
			width: 40px;
			height: 25px;
			background: #fff;
			opacity: 0.5;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #333;
			font-size: 12px;
			margin-left: auto;
		}
	}
	.ssinput{
		background: none;
		border: none;
		width: 70%;
		height: 100%;
		outline: none;
	}
	.el-icon-searchsss{
		margin-left: auto;
		cursor: pointer;
	}
	.huanjingleft{
		width: 252px;
		height: 280px;
		position: relative;
		.huanjingleft01{
			color: #333;
			font-size: 32px;
		}
		.huanjingleft02{
			color: #999999;
			font-size: 14px;
			margin-top: 10px;
		}
		.huanjingleft03{
			width: 100%;
			height: 80px;
			position: absolute;
			left: 0px;
			bottom: 0px;

		}
	}
	.huanjingright{
		width: 1200px;
		height: 280px;
		display: flex;
		// align-items: center;
		// margin-left: auto;
		.huanjingrights{
			width: 280px;
			height: 280px;
			background: #767676;
			position: relative;
			cursor: pointer;
			transition: all 1s;
			margin-left: 20px;
			.zhubeijing{
				width: 100%;
				height: 100%;
				position: absolute;
				z-index: 1;
			}
		}
		.huanjingrights:hover{
				transform: scale(1.05);
		}
		// .huanjingrights:hover .jhsas{
		// 	color: #00b0f0;
		// }

	}
	.list05{
		width: 48%;
		.list05s:hover{
			color: #00b0f0;
		}
		.list05s{
			width: 100%;
			display: flex;
			align-items: center;
			padding-top: 5px;
			padding-bottom: 5px;
			cursor: pointer;
			color: #747474;
			font-size: 14px;
			.list05title{
				width: 70%;
				
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
			}
			.list05time{
				margin-left: auto;
			}
			img{
				width: 20px;
				margin-left: -10px;
			}
		}
	}
	.nav{
		display: flex;
		align-items: center;
		cursor: pointer;
		.navss{
			position: relative;
			color: #00b0f0!important;
		}
		.navss:after{
			content: '';
			display: block;
			width: 83%;
			height: 3px;
			background-color: #00b0f0;
			position: absolute;
			left: 50%;
			margin-left: -41.5%;
			bottom: -12px;
		}
		.navs{
		
			text-align: center;
			color: #404040;
			font-size: 26px;
			padding-left:20px;
			padding-right: 20px;
			cursor: pointer;
			position: relative;
			display: flex;
			align-items: center;
			// letter-spacing: 0.1em;
			img{
				width: 30px;
				height: 30px;
				margin-right: 15px;
			}
		}
		.navssss:before{
			content: '';
			display: block;
			width: 1px;
			height: 26px;
			background-color: #d5d5d5;
			position: absolute;
			top: 8px;
			right: 0;
		}
	}
	.huati001:hover{
		color: #00b0f0;
	}
	.huati003:hover{
		color: #00b0f0;
	}
	.h01:hover{
		color: #00b0f0;
	}
	.h02:hover{
		color: #00b0f0;
	}
	.huati{
		width: 100%;
		height: 100%;
		margin-top: 20px;
		.clears{
			width: 1px;
			height: 50px;
			background: #ececec;
			margin-left: 5px;
			
		}
		.huatis{
			width: 100%;
			height: 72px;
			display: flex;
			align-items: center;
			margin-left: 15px;
			cursor: pointer;
			.huati02{
				width: 270px;
				height: 100%;
				display: flex;
				justify-content: center;
				flex-direction: column;
				margin-left: auto;
				.h01{
					    text-overflow: ellipsis;
					    overflow: hidden;
					    white-space: nowrap;
					    font-size: 16px;
					    color: #747474;
				}
			    .h02{
					margin-top: 8px;
					    font-size: 14px;
					    color: #747474;
				}
			}
			.huati01{
				width: 45px;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				.huati001{
					font-size: 16px;
					color: #747474;
				}
				.huati002{
					    width: 5px;
					    height: 5px;
					    background-color: #747474;
					    border-radius: 10px;
						margint-top:5px;
						margin-bottom: 5px;
				}
				.huati003{
					line-height: 17px;
					    font-size: 12px;
					    color: #747474;
				}
			}
		}
	}
	.wrappers02{
		width: 345px;
		margin-right: 5px;
		height: 100%;
		.flexgb{
			width: 100%;
			height: 57px;
			border-bottom: 1px solid #bbcae6;
			display: flex;
			align-items: center;
			.flexAc{
				color: #00b0f0;
				font-size: 14px;
				margin-left: auto;
				height:100%;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
			}
		}
	}
	.transition{
		width: 95%;
		margin: 0 auto;
		.list{
			width: 100%;
			height: 390px;
			padding-top: 38px;
			display: flex;
			.lists{
				width: 48%;
				height: 100%;
				cursor: pointer;
				.list04:hover{
					color: #00b0f0;
				}
				.list04{
					margin: 20px 0 0;
					padding-bottom: 15px;
					border-bottom: 1px solid #d6d6d6;
					display: flex;
					align-items: center;
					font-size: 14px;
					color: #747474;

					.time01{
						margin-left: auto;
						display: flex;
						align-items: center;
						img{
							width: 30px;
							margin-left: 20px;
						}
					}
				}
				.list02{
					margin-top: 23px;
					height: 35px;
					text-overflow: ellipsis;
					white-space: nowrap;
					overflow: hidden;
					font-size: 16px;
					color: #000;
				}
				.list03{
					line-height: 22px;
					min-height:66px;
					max-height: 66px;
					font-size: 14px;
					color: #747474;
					-webkit-transition: all .5s;
					display: -webkit-box;
					-webkit-line-clamp: 3;
					overflow: hidden;
					text-overflow: ellipsis;
					-webkit-box-orient: vertical;
				}
				.list03:hover{
					color: #00b0f0;
				}
				.list02:hover{
					color: #00b0f0;
				}
				.list01{
					width:100%;
					height: 220px;
					border-radius: 5px;
					background: #f5f5f5;
					img{
						width: 100%;
						height: 100%;
						border-radius: 5px;
						transition: all 1s;
					}
					img:hover{
						transform: scale(1.1);
					}
				}
			}
			.lists:nth-child(2){
				margin-left: auto;
			}
		}

	}
	.wrapper{
		width: 1200px;
		margin: 0 auto;
		.wrappers{
			display: flex;
			// height: 800px;
			// margin-top:30px;
			.wrappers01{
				width: 816px;
				height: 100%;
				.flexgb{
					width: 100%;
					height: 57px;
					border-bottom: 1px solid #bbcae6;
					display: flex;
					.flexAc{
						color: #00b0f0;
						font-size: 14px;
						margin-left: auto;
						height:100%;
						display: flex;
						align-items: center;
						justify-content: center;
						cursor: pointer;
					}
				}
			}
			.wrappers02{
				width: 345px;
				height: 100%;
				margin-left: auto;
			}
		}
	}
	.swiper{
		width: 80%;
		margin: 0 auto;
		.el-carousel-item{
			width: 100%;
			height: 100%;
			img{
				width: 100%;
				height: 100%;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/index/index.vue